import AdminUserPage from './AdminUserPage';

const Did = () => <AdminUserPage user="Did" />;

export default Did;
